import { useNavigate } from "react-router-dom";
import { useState } from "react";
import * as Yup from "yup";

import Master from "../../../Layouts/Master";
import { useApi } from "../../../Hooks/Api";
import { useToast } from "../../../Hooks/Toast";
import { Form, Text } from "../../../Components/Form";
import { serverErrorHandler } from "../../../Utils/Helpers";
import TitleBar from "../../../Components/TitleBar/TitleBar";

const validationSchema = Yup.object({
  weight: Yup.string().typeError("وزن الزامی است").required("وزن الزامی است"),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await post(
      "/weight",
      values,
      (res) => {
        success(`وزن "${values?.weight}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate("/weight");
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error("لطفا خطاهای فرم را رفع کنید.");
        } else {
          error(`وزن "${values?.weight}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      }
    );
  };
  return (
    <Master>
      <TitleBar
        title='ایجاد وزن'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/weight'
      />
      <Form
        initialValues={{
          weight: "",
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12'>
            <div className='col-12'>
              <Text
                title='وزن'
                name='weight'
                serverError={serverErrors.weight}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
